import NprSuggest from '../../NprSuggest';
import { NprResultTypes } from '@src/utils/enums';
import { getParentObject } from '../../nprData.types';
import { commonQuestionData, QuestionDataById } from '@components/dynamic-form/types';

export const nprQuestionsById: QuestionDataById = {
  1: {
    sectionId: 1,
    helpInfo:
      'Examples include: Floating docks, powerlines, dredging, and informational buoys located in, over, or under a navigable water. Definitions for Section 10 of the Rivers and Harbors Act of 1899 are provided at [33 CFR 322.2](https://www.ecfr.gov/current/title-33/section-322.2).',
    question:
      'Are you planning to conduct work or install structures in, over, or under navigable water of the United States?',
    questionTypeId: 7,
    lists: [
      {
        listId: 1,
        valueDesc: 'Yes',
        sortOrder: 1.0,
        activeInd: true,
      },
      {
        listId: 1,
        valueDesc: 'No',
        sortOrder: 1.0,
        activeInd: true,
      },
      {
        listId: 1,
        valueDesc: "I'm not sure",
        sortOrder: 1.0,
        activeInd: true,
      },
    ],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.PermitRequired} />,
      },
      {
        value: "I'm not sure",
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  2: {
    sectionId: 1,
    helpInfo: `Examples include:
      - Placement of fill that is necessary for the construction of any structure or infrastructure in a water of the United States
      - The building of any structure, infrastructure, or impoundment requiring rock, sand, dirt, or other material for its construction
      - Site-development fills for recreational, industrial, commercial, residential, or other uses; causeways or road fills
      - Dams and dikes
      - Artificial islands
      - Property protection and/or reclamation devices such as riprap, groins, seawalls, breakwaters, and revetments
      - Beach nourishment
      - Levees
      - Fill for structures such as sewage treatment facilities, intake and outfall pipes associated with power plants and subaqueous utility lines
      - Placement of fill material for construction or maintenance of any liner, berm, or other infrastructure associated with solid waste landfills
      - Placement of overburden, slurry, or tailings or similar mining-related materials
      - Artificial reefs
  Definitions for Section 404 of the Clean Water Act are provided at [33 CFR 322.2](https://www.ecfr.gov/current/title-33/section-322.2).`,
    question:
      'Are you planning to discharge (dump, place, deposit, redistribute) dredged or fill material into waters of the United States?',
    questionTypeId: 7,
    lists: [
      {
        listId: 1,
        valueDesc: 'Yes',
        sortOrder: 1.0,
        activeInd: true,
      },
      {
        listId: 1,
        valueDesc: 'No',
        sortOrder: 1.0,
        activeInd: true,
      },
      {
        listId: 1,
        valueDesc: "I'm not sure",
        sortOrder: 1.0,
        activeInd: true,
      },
    ],
    parentQuestions: [getParentObject(8, 5, '=', 'NO')],
    endConditions: [
      {
        value: "I'm not sure",
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  3: {
    sectionId: 1,
    question: 'Are you constructing a floating dock that has no associated discharge of fill material?',
    questionTypeId: 5,
    parentQuestions: [getParentObject(2, 7, '=', 'NO')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.NprLetter} />,
      },
    ],
    ...commonQuestionData,
  },
  4: {
    sectionId: 1,
    question: 'Are you excavating material from a Section 404 water with no associated discharge of fill material?',
    questionTypeId: 5,
    parentQuestions: [getParentObject(3, 5, '=', 'NO')],
    ...commonQuestionData,
  },
  5: {
    sectionId: 1,
    helpInfo: `Incidental fallback means the redeposit of small volumes of dredged material that is incidental to excavation activity in waters of the United States when such material falls back to substantially the same place as the initial removal.
Additional information regarding incidental fallback can be found at:
 1. [33 CFR 323.2(d)(3)](https://www.ecfr.gov/current/title-33/part-323#p-323.2(d)(3)(i))
 2. [33 CFR 323.2(d)(3)(ii)](https://www.ecfr.gov/current/title-33/part-323#p-323.2(d)(3)(ii))`,
    question: 'Will your project only involve incidental fallback in a water of the US?',
    questionTypeId: 5,
    parentQuestions: [getParentObject(4, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.NprLetter} />,
      },
    ],
    ...commonQuestionData,
  },
  6: {
    sectionId: 1,
    helpInfo:
      'Pile supported structures such as piers, boardwalks and walkways are typically not considered fill material when placed in waters of the U.S.',
    question: 'Are you constructing a pile supported structure with no associated discharge of fill material?',
    questionTypeId: 5,
    parentQuestions: [getParentObject(5, 5, '=', 'NO'), getParentObject(4, 5, '=', 'NO')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  7: {
    sectionId: 1,
    helpInfo: `Examples of projects that would cause the effect of fill include:
    - Projects where the pilings are so closely spaced that sedimentation rates would be increased
    - Projects in which the pilings themselves effectively would replace the bottom of a waterbody
    - Projects involving the placement of pilings that would reduce the reach or impair the flow or circulation of waters of the United States
    - Projects involving the placement of pilings which would result in the adverse alteration or elimination of aquatic functions`,
    question: 'Will the piles be placed in a manner so they do not cause the effect of fill?',
    questionTypeId: 5,
    parentQuestions: [getParentObject(6, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.NprLetter} />,
      },
      {
        value: 'NO',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.PermitRequired} />,
      },
    ],
    ...commonQuestionData,
  },
  8: {
    sectionId: 1,
    helpInfo:
      'Definitions for Section 103 of the Marine Protection, Research, and Sanctuaries Act are provided at [33 CFR 324.2](https://www.ecfr.gov/current/title-33/section-324.2).',
    question: 'Are you planning to transport dredged material for the purpose of dumping it in ocean waters?',
    questionTypeId: 5,
    parentQuestions: [getParentObject(1, 7, '=', 'NO')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.PermitRequired} />,
      },
    ],
    ...commonQuestionData,
  },
  9: {
    sectionId: 2,
    helpInfo:
      'These exemptions do not apply to any activity within a navigable water of the U.S. in which a permit is required under Section 10 of the Rivers and Harbors Act of 1899.',
    question: 'Does your project involve impacts to a Navigable Water of the US (Section 10)?',
    questionTypeId: 7,
    lists: [
      {
        listId: 1,
        valueDesc: 'Yes',
        sortOrder: 1.0,
        activeInd: true,
      },
      {
        listId: 1,
        valueDesc: 'No',
        sortOrder: 1.0,
        activeInd: true,
      },
      {
        listId: 1,
        valueDesc: "I'm not sure",
        sortOrder: 1.0,
        activeInd: true,
      },
    ],
    parentQuestions: [getParentObject(2, 7, '=', 'YES')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.PermitRequired} />,
      },
      {
        value: "I'm not sure",
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  10: {
    sectionId: 2,
    helpInfo:
      'If any discharge resulting from the exempt activities contains any toxic pollutant listed under Section 307 of the Clean Water Act, the discharge will be subject to any applicable toxic effluent standard or prohibition, and will require a Section 404 permit.',
    question: 'Does the discharge contain a toxic pollutant listed under Section 307 of the Clean Water Act?',
    questionTypeId: 5,
    parentQuestions: [getParentObject(9, 7, '=', 'NO')],
    endConditions: [
      {
        questionTypeId: 5,
        value: 'YES',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.PermitRequired} />,
      },
    ],
    ...commonQuestionData,
  },
  11: {
    sectionId: 2,
    helpInfo: `The recapture provision is a two part test. This provision applies when the discharge is part of an activity intended to convert an area of waters of the United States to a new use, AND that conversion impairs the flow or circulation of waters or reduces their reach.
The activity is recaptured and requires a permit if it meets both of the following criteria:
 1. Change in Use: The activity has the purpose of converting a water body (like a wetland) into a use to which it was not previously subject (e.g., converting it to upland).
 2. Harm to Waters: The discharge causes or is part of an activity that impairs the flow or circulation of waters of the United States or reduces the reach of those waters.`,
    question:
      'Will any part of the discharge convert an area of a water of the U.S. into a use to which it was not previously subject, where the flow and/or circulation of waters may be impaired or the reach of the waters reduced?',
    questionTypeId: 7,
    lists: [
      {
        listId: 1,
        valueDesc: 'Yes',
        sortOrder: 1.0,
        activeInd: true,
      },
      {
        listId: 1,
        valueDesc: 'No',
        sortOrder: 1.0,
        activeInd: true,
      },
      {
        listId: 1,
        valueDesc: "I'm not sure",
        sortOrder: 1.0,
        activeInd: true,
      },
    ],
    parentQuestions: [getParentObject(10, 5, '=', 'NO')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.PermitRequired} />,
      },
      {
        value: "I'm not sure",
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  12: {
    sectionId: 2,
    helpInfo:
      'To fall under this exemption, the activities must be part of an established farming, silviculture, or ranching operation. These activities include plowing, seeding, cultivating, harvesting food, fiber, and forest products, or upland soil and water conservation practices. This specific exemption does not apply to farm or stock ponds or drainage ditches, they are addressed in a later exemption. [Learn more information on this exemption.](https://www.ecfr.gov/current/title-33/chapter-II/part-323/section-323.4)',
    question:
      'Does your project involve the discharge of dredged or fill material for normal farming, silviculture, and ranching activities such as plowing, seeding, cultivating, minor drainage, harvesting for the production of food, fiber, and forest products, or upland soil and water conservation practices?',
    questionTypeId: 5,
    parentQuestions: [getParentObject(11, 7, '=', 'NO')],
    ...commonQuestionData,
  },
  13: {
    sectionId: 2,
    helpInfo:
      'Activities on areas laying fallow as part of a conventional rotational cycle are part of an established operation. Activities that bring an area into farming, silviculture, or ranching use are not part of an established operation. An operation is not longer established when the area on which it was conducted has been converted to another use or has lain idle so long that modifications to the hydrologic regime are necessary to resume operations.',
    question: 'Is the activity part of an established farming, silviculture, or ranching operation?',
    questionTypeId: 5,
    parentQuestions: [getParentObject(12, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.PermitRequired} />,
      },
      {
        value: 'YES',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.NprExemption} />,
      },
    ],
    ...commonQuestionData,
  },
  14: {
    sectionId: 2,
    question:
      'Does your project involve the discharge of dredged or fill material for the purpose of maintenance, including emergency reconstruction of recently damaged parts of currently serviceable structures such as dikes, dams, levees, groins, riprap, breakwaters, causeways, bridge abutments or approaches, or transportation structures?',
    questionTypeId: 5,
    parentQuestions: [getParentObject(12, 5, '=', 'NO')],
    ...commonQuestionData,
  },
  15: {
    sectionId: 2,
    question: 'Will the activity modify the character, scope, or size of the original fill design?',
    questionTypeId: 5,
    parentQuestions: [getParentObject(14, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.PermitRequired} />,
      },
    ],
    ...commonQuestionData,
  },
  16: {
    sectionId: 2,
    question:
      'If reconstruction is necessary due to damage, will the activity occur within a reasonable period of time after damage?',
    questionTypeId: 5,
    parentQuestions: [getParentObject(15, 5, '=', 'NO')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.PermitRequired} />,
      },
    ],
    ...commonQuestionData,
  },
  17: {
    sectionId: 2,
    helpInfo:
      'Temporary discharges incidental to a maintenance activity that is exempt under Section 404(f) are also exempt.',
    question: 'Will your project involve more than temporary impacts associated with the maintenance activity?',
    questionTypeId: 5,
    parentQuestions: [getParentObject(16, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.PermitRequired} />,
      },
      {
        value: 'NO',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.NprExemption} />,
      },
    ],
    ...commonQuestionData,
  },
  18: {
    sectionId: 2,
    question:
      'Does your project involve the discharge of dredged or fill material for the purpose of construction or maintenance of farm or stock ponds?',
    questionTypeId: 5,
    parentQuestions: [getParentObject(14, 5, '=', 'NO')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.PreApplication} />,
      },
    ],
    ...commonQuestionData,
  },
  35: {
    sectionId: 2,
    helpInfo:
      'See [RGL 07-02](https://www.federalregister.gov/documents/2007/12/13/E7-24191/us-army-corps-of-engineers-corps-regulatory-guidance-letter-rgl-07-02-exemptions-for-construction-or) and the [Ditch Exemption Memo](https://www.epa.gov/system/files/documents/2022-12/Ditch%20Exemption%20Memo_Final.pdf) for additional information on the construction and maintenance of irrigation ditches and maintenance of drainage ditches, including definitions for irrigation ditches, drainage ditches, construction and maintenance.',
    question:
      'Does your project involve the discharge of dredged or fill material for the purpose of construction or maintenance of irrigation ditches, or the maintenance of drainage ditches?',
    questionTypeId: 5,
    parentQuestions: [getParentObject(18, 5, '=', 'NO')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.NprExemption} />,
      },
    ],
    ...commonQuestionData,
  },
  24: {
    sectionId: 2,
    helpInfo:
      'This exemption applies to the construction of temporary sedimentation basins on a construction site which does not include the placement of fill material into waters of the U.S.',
    question:
      'Does your project involve the discharge of dredged or fill material for the purpose of construction of temporary sedimentation basins on a construction site which does not include placement of fill material into the water of the US?',
    questionTypeId: 5,
    parentQuestions: [getParentObject(35, 5, '=', 'NO')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.NprExemption} />,
      },
    ],
    ...commonQuestionData,
  },
  25: {
    sectionId: 2,
    helpInfo: 'Forest road means logging road or road associated with silviculture.',
    question:
      'Does your project involve the discharge of dredged or fill material for the purpose of construction or maintenance of farm roads or forest roads, or temporary roads for moving mining equipment, where such roads are constructed and maintained, in accordance with best management practices, to assure that flow and circulation patterns and chemical and biological characteristics of the navigable waters are not impaired, that the reach of the navigable waters is not reduced, and that any adverse effect on the aquatic environment will be otherwise minimized?',
    questionTypeId: 5,
    parentQuestions: [getParentObject(24, 5, '=', 'NO')],
    ...commonQuestionData,
  },
  26: {
    sectionId: 2,
    question:
      'Is the road designed to be the minimal feasible number of roads, width, and length for the specific farming, silviculture, or mining operation?',
    questionTypeId: 5,
    parentQuestions: [getParentObject(25, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.PermitRequired} />,
      },
    ],
    ...commonQuestionData,
  },
  27: {
    sectionId: 2,
    question:
      'Will the road be designed to allow the passage of expected flood flows through installation of bridges, culverts, etc.?',
    questionTypeId: 5,
    parentQuestions: [getParentObject(26, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.PermitRequired} />,
      },
    ],
    ...commonQuestionData,
  },
  28: {
    sectionId: 2,
    question: 'Will the road be designed to not disrupt the migration or movement of aquatic life?',
    questionTypeId: 5,
    parentQuestions: [getParentObject(27, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.PermitRequired} />,
      },
    ],
    ...commonQuestionData,
  },
  29: {
    sectionId: 2,
    question: 'Will the discharge be located in the proximity of a public water supply intake?',
    questionTypeId: 5,
    parentQuestions: [getParentObject(28, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.PermitRequired} />,
      },
    ],
    ...commonQuestionData,
  },
  30: {
    sectionId: 2,
    question: 'Will the discharge be located in area of concentrated shellfish production?',
    questionTypeId: 5,
    parentQuestions: [getParentObject(29, 5, '=', 'NO')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.PermitRequired} />,
      },
    ],
    ...commonQuestionData,
  },
  31: {
    sectionId: 2,
    helpInfo:
      'Component means a stream designated under the Wild and Scenic River system.  Additional information is available on the [find a river tool on rivers.gov](https://rivers.gov/rivers/apps/find-a-river).',
    question: 'Will the discharge take place in a component of the National Wild and Scenic River system?',
    questionTypeId: 5,
    parentQuestions: [getParentObject(30, 5, '=', 'NO')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.PermitRequired} />,
      },
    ],
    ...commonQuestionData,
  },
  32: {
    sectionId: 2,
    question:
      'Will the discharge of material consist of suitable material free from toxic pollutants in toxic amounts?',
    questionTypeId: 5,
    parentQuestions: [getParentObject(31, 5, '=', 'NO')],
    endConditions: [
      {
        value: 'NO',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.PermitRequired} />,
      },
    ],
    ...commonQuestionData,
  },
  33: {
    sectionId: 2,
    question: 'Will all temporary fills be removed in their entirety and the area restored to its original elevation?',
    questionTypeId: 5,
    parentQuestions: [getParentObject(32, 5, '=', 'YES')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.NprExemption} />,
      },
      {
        value: 'NO',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.PermitRequired} />,
      },
    ],
    ...commonQuestionData,
  },
  34: {
    sectionId: 2,
    question:
      'Does your project involve the discharge of dredged or fill material resulting from any activity with respect to which a State has an approved program under section 1288(b)(4) of this title which meets the requirements of subparagraphs (B) and (C) of such section, is not prohibited by or otherwise subject to regulation under this section or section 1311(a) or1342 of this title (except for effluent standards or prohibitions under section 1317 of this title?',
    questionTypeId: 5,
    parentQuestions: [getParentObject(25, 5, '=', 'NO')],
    endConditions: [
      {
        value: 'YES',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.NprExemption} />,
      },
      {
        value: 'NO',
        comparison: '=',
        content: <NprSuggest nprResult={NprResultTypes.PermitRequired} />,
      },
    ],
    ...commonQuestionData,
  },
};

export const nprQuestions = [
  nprQuestionsById[1],
  nprQuestionsById[8],
  nprQuestionsById[2],
  nprQuestionsById[3],
  nprQuestionsById[4],
  nprQuestionsById[5],
  nprQuestionsById[6],
  nprQuestionsById[7],
];

export const exemptionQuestions = [
  nprQuestionsById[9],
  nprQuestionsById[10],
  nprQuestionsById[11],
  nprQuestionsById[12],
  nprQuestionsById[13],
  nprQuestionsById[14],
  nprQuestionsById[15],
  nprQuestionsById[16],
  nprQuestionsById[17],
  nprQuestionsById[18],
  nprQuestionsById[35],
  nprQuestionsById[24],
  nprQuestionsById[25],
  nprQuestionsById[26],
  nprQuestionsById[27],
  nprQuestionsById[28],
  nprQuestionsById[29],
  nprQuestionsById[30],
  nprQuestionsById[31],
  nprQuestionsById[32],
  nprQuestionsById[33],
  nprQuestionsById[34],
];
